// extracted by mini-css-extract-plugin
module.exports = {"link":"Link_link__284Gj","disabled":"Link_disabled__3Rj0_"};